<template>
    <section class="ws_page_section">
        <div class="ws_frame_box clearfix">
            <div class="common_page_header">
                <button type="button" tapable="" class="btn btn-white-transparent back_btn" @click="$router.go(-1)"><i aria-hidden="true"
                        class="fa fa-chevron-left"></i></button> Support Workpsace
            </div>
            <div class="ws_chat_frame">
                <chat-list></chat-list>
                <chat-info></chat-info>
            </div>
        </div>
    </section>
</template>

<script>
/*eslint-disable */
import chatInfo from '@/components/workspace/chat-info/';
import chatListSidebar from '@/components/workspace/chat-list-sidebar-support/';
// import toolRightSidebar from '@/components/workspace/workspace-right-sidebar/';
export default {
    name: 'support-workspace',
    components: {
        'chat-list': chatListSidebar,
        'chat-info': chatInfo,
        // 'tool-right-sidebar' : toolRightSidebar
    },
    props: [],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}



</script>

<style lang="scss" scoped>
.ws_page_section {
    .common_page_header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        border-bottom: solid 1px rgba(228, 233, 237, 0.1);
        position: relative;
        font-family: 'MyriadProSemibold', 'Lato', sans-serif;
        font-weight: normal;
        font-size: 22px;
        padding: 10px 15px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .ws_frame_box {
        background: rgba(0, 0, 0, .6);
        border-radius: 3px;
        min-height: calc(100vh - 110px);
    }

    .ws_chat_frame {
        width: 100%;
        height: calc(100vh - 175px);
        float: left;
        padding: 15px 15px 0;

        @media only screen and (max-width:767px) {
            width: 100%;
        }
    }

    .ws_tool_frame {
        width: calc(32% - 2px);
        float: left;
        height: calc(100vh - 110px);
        padding-left: 10px;

        @media only screen and (max-width:767px) {
            width: 100%;
            display: none;
        }
    }
}
</style>